module.exports = __webpack_public_path__ + "static/img/duorentianbiao-wx.1a63abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/duorentianbiao-wx.jpg
// module id = Pf9D
// module chunks = 1